// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3YMtJ","productName":"Table_productName__2N7y9"};